// components/Apps/Quiz/DualScaleAnswerOptions.js
import React from 'react';
import PropTypes from 'prop-types';

const DualScaleAnswerOptions = ({ leftLabel, rightLabel, selectedAnswer, onAnswer }) => {
  return (
    <div className="quiz-dual-scale">
      <div className="quiz-dual-scale__labels">
        <span className="quiz-dual-scale__label">{leftLabel}</span>
        <span className="quiz-dual-scale__label">{rightLabel}</span>
      </div>
      <input
        type="range"
        min="1"
        max="10"
        value={selectedAnswer || 5}
        onChange={(e) => onAnswer(parseInt(e.target.value))}
        className="quiz-dual-scale__slider"
      />
      <div className="quiz-dual-scale__value">{selectedAnswer || 5}</div>
    </div>
  );
};

DualScaleAnswerOptions.propTypes = {
  leftLabel:      PropTypes.string,
  rightLabel:     PropTypes.string,
  selectedAnswer: PropTypes.number,
  onAnswer:       PropTypes.func.isRequired,
};

export default DualScaleAnswerOptions;